import {Model} from "@vuex-orm/core";
import BeneficiaryAssignment from "./BeneficiaryAssignment";

export default class Trust extends Model {
    /* Follow the namespace in the backend */
    static entity = 'Household\\Model\\Trust';

    static fields() {
        return {
            id: this.attr(null),
            household_id: this.number(null),
            name: this.attr(''),
            attorney_name: this.attr(''),
            attorney_contact: this.attr(''),
            note: this.attr(''),
            beneficiaryAssignmentsAsAssigned: this.morphMany(BeneficiaryAssignment, 'assigned_id', 'assigned_type'),
            beneficiaryAssignments: this.morphMany(BeneficiaryAssignment, 'assignable_id', 'assignable_type'),
        }
    }

    get displayName() {
        return this.name;
    }

    get type() {
        return 'Household\\Model\\Trust';
    }
}
